import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { getFormValues, isValid, reduxForm, reset, touch, focus } from 'redux-form';

import * as validFunc from 'libs/validation';
import * as userLib from 'libs/userLib';
import * as registerLib from 'libs/registerLib';

import { Image, Button, Label } from 'semantic-ui-react';

import { ReduxFormMaterialTextField, LoginTemplate } from 'components';

import classNames from 'classnames/bind';
import styles from './CtAdminLogin.css';
const cx = classNames.bind(styles);

class CtFirstLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorMessage: {
        type: '',
        content: ''
      }
    };
  }

  // 관리자 계정 최초 수정
  onInitSetting = async () => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        // 국제화 처리
        const { formatMessage } = this.props.intl;
        const { formInitSetting, isValidFormInitSetting, userEmail } = this.props;

        if (isValidFormInitSetting) {
          this.setState({ isClicked: true });

          if (formInitSetting.userPasswd === formInitSetting.userPasswdCheck) {
            const param = {
              userEmailId: userEmail.split('@')[0],
              userPasswd: formInitSetting.userPasswd
            };
            const respObj = await registerLib.checkPasswordAPI(param);
            if (respObj && respObj.status && respObj.status === 200) {
              // 비밀번호 규칙 실패
              if (
                respObj.data &&
                Array.isArray(respObj.data.list) &&
                respObj.data.list[0].error &&
                !!respObj.data.list[0].error.bit
              ) {
                const { error } = respObj.data.list[0];
                this.setState({
                  errorMessage: {
                    type: 'userPasswd',
                    content: (
                      <span>
                        {validFunc.passwordVlidation(error).map((errorDetial, index) => {
                          return (
                            <span key={index} className="display-block mtb-5">
                              {errorDetial}
                            </span>
                          );
                        })}
                      </span>
                    )
                  }
                });

                this.setState({ isClicked: false });
                // 비밀번호 변경
              } else {
                const params = {
                  userPasswd: formInitSetting.userPasswd
                };

                const respObjInit = await userLib.initSetting(params);
                if (respObjInit && respObjInit.status && respObjInit.status === 200 && respObjInit.data) {
                  if (Array.isArray(respObjInit.data.list)) {
                    // ID/Password 변경 성공
                    this.setState({
                      errorMessage: {
                        type: 'success',
                        content: (
                          <div>
                            <div className={cx('brand bold font-size-16')}>
                              {defineMessages(formatMessage({ id: 'CtFirstLogin_5', defaultMessage: '변경 완료!' }))}
                            </div>
                          </div>
                        )
                      }
                    });
                  } else {
                    if (respObjInit.data.error && respObjInit.data.error[0].errInfo) {
                      this.setState({
                        errorMessage: {
                          type: 'userPasswd',
                          content: respObjInit.data.error[0].errInfo
                        }
                      });
                    } else {
                      console.log('error 상황');
                    }
                  }
                } else {
                  // 응답 오류
                }
              }
            }
          } else {
            // 비밀번호와 비밀번호 체크 일치 안함
            this.setState({
              errorMessage: {
                type: 'userPasswd',
                content: defineMessages(
                  formatMessage({ id: 'CtAdminChangePW_3', defaultMessage: '비밀번호가 일치하지 않습니다.' })
                )
              }
            });
          }
        } else {
          this.markFieldValidate('formInitSetting');
        }
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  // 로그인
  onMove = () => {
    return window.location.replace('/main');
  };

  // 취소
  onCancel = () => {
    return window.location.reload();
  };

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  handleKeyPress = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.onInitSetting();
    }
  };

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <LoginTemplate isHideLogo>
        <div className={cx('admin-first-edit-area')}>
          <div className={cx('display-flex flex-start')}>
            <Image src="/img/logo/m_logo.png" />
            <div>
              <Label className={cx('admin-title')}>
                {defineMessages(
                  formatMessage({ id: 'CtFirstLogin_7', defaultMessage: '비밀번호 변경 (관리자에 의해 지정됨)' })
                )}
              </Label>
              <div className={cx('admin-sub-title')}>
                <div>
                  {defineMessages(
                    formatMessage({ id: 'CtFirstLogin_8', defaultMessage: '관리자가 지정한 비밀번호입니다.' })
                  )}
                </div>
                <div>
                  {defineMessages(formatMessage({ id: 'CtFirstLogin_9', defaultMessage: '새 비밀번호로 변경하세요.' }))}
                </div>
              </div>
            </div>
          </div>
          {this.state.errorMessage.type === 'success' ? (
            <div className={cx('first-login-area')}>{this.state.errorMessage.content}</div>
          ) : (
            <div className={cx('first-login-area')}>
              <div className={cx('wrap-input')}>
                <ReduxFormMaterialTextField
                  type="password"
                  label={defineMessages(formatMessage({ id: 'ModalEditPassword_5', defaultMessage: '새 비밀번호' }))}
                  fullWidth
                  validate={['required', 'gsPassword']}
                  name="userPasswd"
                  checkType={100}
                  onKeyPress={this.handleKeyPress}
                  error={this.state.errorMessage.type === 'userPasswd' ? true : false}
                  helperText={this.state.errorMessage.type === 'userPasswd' && this.state.errorMessage.content}
                />
                <ReduxFormMaterialTextField
                  type="password"
                  label={defineMessages(
                    formatMessage({ id: 'ModalEditPassword_6', defaultMessage: '새 비밀번호 확인' })
                  )}
                  fullWidth
                  validate={['required', 'gsPassword']}
                  name="userPasswdCheck"
                  checkType={101}
                  onKeyPress={this.handleKeyPress}
                  error={this.state.errorMessage.type === 'userPasswdCheck' ? true : false}
                  helperText={this.state.errorMessage.type === 'userPasswdCheck' && this.state.errorMessage.content}
                />
              </div>
            </div>
          )}
          <div>
            {this.state.errorMessage.type === 'success' ? (
              <div className={cx('button-area')}>
                <Button className={cx('bt-change')} onClick={this.onMove}>
                  {defineMessages(formatMessage({ id: 'CtAdminLogin_4', defaultMessage: '로그인' }))}
                </Button>
              </div>
            ) : (
              <div className={cx('button-area')}>
                <Button className={cx('bt-change')} loading={this.state.isLoading} onClick={this.onInitSetting}>
                  {defineMessages(formatMessage({ id: 'CtFirstLogin_1', defaultMessage: '변경' }))}
                </Button>
                <Button className={cx('bt-noChange')} loading={this.state.isLoading} onClick={this.onCancel}>
                  {defineMessages(formatMessage({ id: 'CtFirstLogin_2', defaultMessage: '취소' }))}
                </Button>
              </div>
            )}
          </div>
        </div>
      </LoginTemplate>
    );
  }
}

const mapStateToProps = state => ({
  formInitSetting: getFormValues('formInitSetting')(state),
  isValidFormInitSetting: isValid('formInitSetting')(state),
  formStore: state.form['formInitSetting']
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formInitSetting',
    enableReinitialize: true,
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(CtFirstLogin))
);



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtFirstLogin.js